import React from 'react'
import { PropTypes } from 'prop-types'
import commaNumber from 'comma-number'
import CancelPolicyComponent from '../../common/components/cancel_policy/cancel_policy_component'
import './PriceInfo.scss'
import { Trans, withNamespaces } from "react-i18next"
import { compose } from 'redux'
import CurrencyHelper from '../../common/helpers/currency_helper'

class CancelPolicy extends CancelPolicyComponent {
  render() {
    const { t } = this.props
    return <dl styleName="cancel-policy-description" className="n-text" style={{ fontWeight: 'bold' }}>
      {this.getDescription().map(({ title, value }, i) => {
        return (
          <div styleName="cancel-policy-row" key={i}>
            <dt styleName={`cancel-policy-span${value == 0 ? ' free' : ''}`} style={{ marginLeft: 0 }}>
              <span>{title}</span>
              <span>
                {value == 0 ? <React.Fragment>
                  <span>{ t('cancel_policy.until') }</span>
                  <span styleName="cancel-free">{ t('cancel_policy.free') }</span>
                </React.Fragment> : ''}
              </span>
            </dt>
            { value > 0 && <dd styleName="cancel-policy-rate">
              <Trans i18nKey="cancel_policy.total_price">合計料金の{{percent: value}}%</Trans>
            </dd> }
          </div>
        )
      })}
    </dl>
  }
}

export class PriceInfo extends React.Component {
  render() {
    const { t } = this.props
    return (
      <React.Fragment>
        {this.props.price_for_extra_person && this.props.persons_for_extra_fee
          ? <section styleName="additional-fee">
            <h2>{ t('addition_person_fee.title') }</h2>
            <p>
              <Trans i18nKey="addition_person_fee.note">
                1部屋あたりの宿泊人数が<em><span className='notranslate'>{{person_for_extra_fee: this.props.persons_for_extra_fee}}</span>名以上</em>になる場合には以下の追加料金が発生します。
              </Trans>
            </p>
            <div styleName="price">
              <span>{ t('addition_person_fee.note_price') }</span>
              <em>
                <span className='notranslate'> +{CurrencyHelper.getSymbolFromSelectedCurrency()}{`${commaNumber(this.props.price_for_extra_person)}`}</span>
                <span>/{ t('room_info.night') }</span>
              </em>
            </div>
          </section> : null
        }
        <section>
          <h2>{ t('cancel_policy.title') }</h2>
          <CancelPolicy cancelPolicy={this.props.cancel_policy} t={t} />
        </section>
      </React.Fragment>
    )
  }
}

PriceInfo.propTypes = {
  price_for_extra_person: PropTypes.number.isRequired,
  persons_for_extra_fee: PropTypes.number.isRequired,
  cancel_policy: PropTypes.string.isRequired,
  cancel_policy_list: PropTypes.array.isRequired
}

export default compose( withNamespaces('listings') )(PriceInfo)
